import React, { useContext, useState, useEffect } from "react";
import { UserContext } from "../UserContext";
import "../componentsCSS/Ranking.css"; // Importer le CSS spécifique à ce composant

const RankingPoup = ({ onClose }) => {
  const { getRanking, userData = {} } = useContext(UserContext);
  const [ranking, setRanking] = useState([]);
  const [ userPosition, setUserPosition] = useState(0)

  useEffect(() => {
    const fetchRanking = async () => {
      try {
        const { ranking, uid } = await getRanking();
        let rankingArray;

        if (Array.isArray(ranking)) {
          rankingArray = ranking;
          console.log("ici ", rankingArray)
        } else if (typeof ranking === "object" && ranking !== null) {

          rankingArray = Object.keys(ranking).map((uid) => ({
            uid,
            ...ranking[uid],
          }));
        } else {
          console.log("ici ", rankingArray)

          rankingArray = [];
        }

        setRanking(rankingArray);

        const position = rankingArray.findIndex((player) => player.uid === uid) + 1; // +1 pour un classement 1-based
        setUserPosition(position);

      } catch (error) {
        console.error("Erreur lors de la récupération du classement :", error);
      }
    };
    fetchRanking();
  }, [getRanking]);

  // Calculer le top 10
  const topTen = Array.isArray(ranking) ? ranking.slice(0, 10) : [];

//   const userDataLocal = JSON.parse(localStorage.getItem("userData")) || {};
//     const userUid = userDataLocal?.uid || null;
//     console.log(userUid)
  // Trouver la position de l'utilisateur
//   const userPosition =
//     ranking.findIndex((player) => player.uid === user_uid) + 1;

  // Vérifier si l'utilisateur est dans le top 10
  const isInTop10 = userPosition > 0 && userPosition <= 10;

  return (
    <div className="ranking-popup-overlay" onClick={onClose}>
      <div className="ranking-wrapper" onClick={(e) => e.stopPropagation()}>
        <h2>Classement</h2>
        <ul className="ranking-list">
          {topTen.map((player, index) => (
            <li key={player.uid} className="ranking-item">
              <span className="ranking-index">{index + 1}.</span>
              <span className="ranking-pseudo">{player.pseudo}</span>
              <span className="ranking-points">{player.points} points</span>
            </li>
          ))}
        </ul>

        {!isInTop10 && userPosition > 0 && (
          <div className="user-position">
            Votre position : {userPosition}ème avec {userData.points} points
          </div>
        )}
        {userPosition === 0 && (
          <div className="user-position">
            Vous n'êtes pas encore classé. Commencez à jouer !
          </div>
        )}

        <button className="close-ranking-button" onClick={onClose}>
          Fermer
        </button>
      </div>
    </div>
  );
};

export default RankingPoup;
